import { createFileRoute } from '@tanstack/react-router';
import { TicketsListScreen } from '@/features/tracking/TicketsListScreen.tsx';
import { requireAuth } from '@/features/auth/guard.ts';
import { q } from '@/lib/queries.ts';

export const Route = createFileRoute('/_app/tickets')({
  beforeLoad: requireAuth,
  loader: ({ context }) => context.queryClient.prefetchQuery(q.segments('upcoming')),
  component: TicketsListScreen,
});
